export const icdPageSx = {
  width: '100%',
  height: '100%',
  minHeight: 0,

  display: 'flex',
  flexDirection: 'column',

  overflow: 'hidden'
};

export const topActionSx = {
  display: 'flex',
  justifyContent: 'flex-end',
  flexShrink: 0,
  mb: 1
};

export const icdPanelsSx = {
  flex: 1,
  minHeight: 0,

  display: 'grid',

  gridTemplateColumns: {
    xs: '1fr',
    md: 'minmax(0, 1fr) minmax(0, 1fr)'
  },

  gridTemplateRows: {
    xs: 'minmax(350px, 1fr) minmax(350px, 1fr)',
    md: 'minmax(0, 1fr)'
  },

  gap: 1.5,

  overflow: {
    xs: 'auto',
    md: 'hidden'
  }
};

export const panelSx = {
  width: '100%',
  height: '100%',
  minHeight: 0,

  display: 'flex',
  flexDirection: 'column',

  border: '1px solid #E2E2E2',
  borderRadius: '8px',

  bgcolor: '#FFFFFF',

  overflow: 'hidden'
};

export const panelHeaderSx = {
  minHeight: 42,

  px: 1.5,

  display: 'flex',
  alignItems: 'center',

  flexShrink: 0,

  borderBottom:
    '1px solid #EEEEEE'
};

export const panelTitleSx = {
  fontSize: 13,
  fontWeight: 500,
  color: '#424242'
};

export const searchRowSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,

  px: 1,
  py: 1,

  flexShrink: 0,

  borderBottom:
    '1px solid #EEEEEE'
};

export const addRowSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,

  px: 1,
  py: 1,

  flexShrink: 0,

  borderBottom:
    '1px solid #EEEEEE'
};

export const diagnosisListSx = {
  flex: 1,
  minHeight: 0,

  display: 'flex',
  flexDirection: 'column',

  overflowY: 'auto',
  overflowX: 'hidden',
  // Keep scrolling

  // Firefox
  scrollbarWidth: 'none',

  // Edge / IE
  msOverflowStyle: 'none',

  // Chrome / Safari
  '&::-webkit-scrollbar': {
    display: 'none',
    width: 0,
    height: 0
  }
};

export const diagnosisRowSx = {
  minHeight: 38,

  px: 1,

  display: 'flex',
  alignItems: 'center',
  gap: 0.5,

  flexShrink: 0,

  borderBottom:
    '1px solid #EEEEEE',

  '&:last-child': {
    borderBottom: 'none'
  },

  '&:hover': {
    bgcolor: '#FFF8ED'
  }
};

export const diagnosisTextSx = {
  flex: 1,
  minWidth: 0,

  fontSize: 12,
  color: '#424242',

  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
};

export const iconButtonSx = {
  width: 28,
  height: 28,

  color: '#757575',

  '&:hover': {
    bgcolor: '#F5F5F5'
  }
};

export const moveButtonSx = {
  width: 22,
  height: 22,

  p: 0,

  border:
    '1px solid #BBDEFB',

  borderRadius: '3px',

  color: '#4A90D9',

  '&:hover': {
    bgcolor: '#EAF4FE'
  }
};

export const searchFieldSx = {
  '& .MuiOutlinedInput-root': {
    height: 36,
    fontSize: 12
  }
};

export const codeFieldSx = {
  width: 120,

  '& .MuiOutlinedInput-root': {
    height: 36,
    fontSize: 12
  }
};

export const descriptionFieldSx = {
  '& .MuiOutlinedInput-root': {
    height: 36,
    fontSize: 12
  }
};

export const saveWrapperSx = {
  display: 'flex',
  justifyContent: 'flex-end',

  flexShrink: 0,

  pt: 1.5
};

export const saveButtonSx = {
  minWidth: 80,
  height: 32,

  px: 2.5,

  bgcolor: '#4A90D9',
  color: '#FFFFFF',

  fontSize: 12,
  fontWeight: 500,

  textTransform: 'uppercase',

  '&:hover': {
    bgcolor: '#3C7FC5'
  }
};